import { render, staticRenderFns } from "./PicturesType.vue?vue&type=template&id=4619a69a&scoped=true&"
import script from "./PicturesType.vue?vue&type=script&lang=js&"
export * from "./PicturesType.vue?vue&type=script&lang=js&"
import style0 from "./PicturesType.vue?vue&type=style&index=0&id=4619a69a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4619a69a",
  null
  
)

export default component.exports